// removed by extract-text-webpack-plugin
module.exports = {"custom-react-slick":"custom-react-slick","hinghlight-item":"hinghlight-item","slick-track":"slick-track","slick-next":"slick-next","slick-prev":"slick-prev","slick-arrow":"slick-arrow","slick-disabled":"slick-disabled","highlight-promotion-container":"highlight-promotion-container","hinghlight-title":"hinghlight-title","red-title":"red-title","banner-demand-row":"banner-demand-row"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_HighlightPromotionContainer.scss
// module id = ./components/home/sub-view/_HighlightPromotionContainer.scss
// module chunks = 0